export default __webpack_public_path__ + "static/media/play.94225db8.svg";